export default "__VITE_ASSET__Ce6qdR5E__"